<template>
    <Sidebar :is_empty="true" />
    <div class="content login-content">
        <Loading v-if="is_loading" />
        <div class="inner">

            <Header title="Sign in to your account" />
     
            <Form v-if="step === 1" :schema="schema" @submit="sendEmail" :values="values" v-slot="{ errors, success }" class="form-wrap" :class="{'show-error': is_error}">
                <Field type="text" k="email"  placeholder="Email address" :error_msg="errors.email" :is_success="success.email" @update="update"/>
                <Field type="password" k="password" placeholder="Password" :error_msg="errors.password" :is_success="success.password" @update="update"/>
                <div v-if="is_error" class="error-text" v-html="error_msg"></div>
                
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" type="submit" @click.native="is_error = false">Log In</Button>
                    <p><router-link to="/reset-password">Forgot password?</router-link></p>
                </div>
            </Form>

            <div v-else-if="step === 2">
                <VerificationCode
                    ref="code" 
                    @resend="sendEmail" 
                    :countdown="countdown" 
                    :error_msg="code_error_msg" 
                    @update="updateCode" 
                    :class="[{'success': code.length === 6 && !code_error}, {'error': code_error}]"
                />
                <Checkbox style="margin-top: 12px; margin-left: 4px;" label_text="Remember my login for 30 days" :checked="values.is_remember" @click.native="values.is_remember = !values.is_remember" :disabled="code.length < 6"/>
                <div class="submit-wrap">
                    <Button :is_disabled="code.length !== 6 || code_error" size="40" color="dark-blue" @click="submit" type="submit">Confirm</Button>
                </div>
            </div>


            <Footer />
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Field from '@/components/ui/Field.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Button from '@/components/ui/Button.vue';
import Form from '@/components/ui/Form.vue';
import Loading from '@/components/ui/Loading.vue';
import VerificationCode from '@/components/ui/VerificationCode.vue';
import Header from '@/components/login/Header.vue';
import Footer from '@/components/login/Footer.vue';
import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);

export default {
    name: 'Login',

    data() {
        return {
            is_loading: false,
            code: '',
            step: 1,
            code_error: false,
            code_error_msg: '',
            is_countdown: false,
            countdown_timer: null,
            countdown_second: 300,
            countdown: 0,
            schema: yup.object().shape({
                email: yup.string().required('The email can’t leave as blank').email('Must be a valid email'),
                password: yup.string()
                    //.password()
                    //.minLowercase(0)
                    //.minUppercase(0)
                    // .minUppercase(1, 'The password must contain at least 1 upper case letter')
                    //.minNumbers(1, 'Must have a number and special character')
                    //.minSymbols(1, 'Must have a number and special character')
                    //.min(14, 'Must be at least 14 characters')
                    .required('The password can’t leave as blank')
            }),
            values: {
                email: '',
                password: '',
                is_remember: false,
            },
            is_error: false,
            error_msg:'* The email and/or password you entered does not match. Please try again or click “Forgot password?” to reset your password.',
        }
    },

    components: {
        Header,
        Footer,
        Sidebar,
        Form,
        Field,
        Checkbox,
        Button,
        Loading,
        VerificationCode,
    },

    methods: {
        update(obj) {
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });
        },

        updateCode(obj) {
            this.code = '';
            for (let index = 0; index < obj.length; index++) {
                if (obj[index]) this.code = this.code + obj[index];
            }

            if (this.code.length === 6) {
                this.code_error = false;
                this.code_error_msg = '';
                //this.submit();
            }
        },

        sendEmail() {
            this.countdown = this.countdown_second;
            this.countdown_timer = window.setInterval(() => {
                this.countdown --;
                
                if (this.countdown === 0) {
                    window.clearInterval(this.countdown_timer);
                }
            }, 1000);

            this.is_loading = true;

            this.$ajax('/send-login-verify-code', {
                method: 'post',
                data: {
                    email: this.values.email,
                    password: this.values.password,
                },
            })
            .then(res => {
                if (res.data.status === 'success') {
                    this.step = 2;
                }

                this.is_loading = false;
            })
            .catch(err => {
                if (err && err.response && err.response.data) 
                {
                    this.is_error = true;
                    this.is_loading = false;
                    if (err.response.data.data.login_failed_attempts === 5) {
                        this.error_msg = `
                            <p>The email address ${this.values.email} has been temporarily locked due to multiple incorrect password attempts. To regain access, please click "<a href="/reset-password">Forgot Password</a>" below, and follow the instructions sent to your email.</p>
                        `;
                    }

                    else if (err.response.data.message) this.error_msg = err.response.data.message;
                    else if (err.response.data.data.message) this.error_msg = err.response.data.data.message;
                }

            });
        },

        sendCode() {
            this.step = 2;
        },
        
        submit() {

            const obj = {
                email: this.values.email,
                password: this.values.password,
                is_remember: this.values.is_remember,
                code: this.code,
            }

            this.is_loading = true;
            this.$ajax('/login', {
                method: 'post',
                data: obj,
                withCredentials: true,
            }).then(res => {

                if (res.data.status === 'success') {
                    // console.log(res.data)
                    localStorage.setItem('access_token', res.data.data.access_token);
                    window.location.replace('/');
                } else {
                    this.code_error = true;
                }

                this.is_loading = false;

            }).catch(err => {

                if (err && err.response && err.response.data) 
                {
                    this.code_error = true;
                    this.is_loading = false;
                    if (err.response.data.message) this.code_error_msg = err.response.data.message;
                    else if (err.response.data.data.message) this.code_error_msg = err.response.data.data.message;
                }

                // else if (err && err.response && err.response.data.data.message) {
                //     this.is_error = true;
                //     this.is_loading = false;
                //     this.error_msg = err.response.data.data.message;
                //     console.log(err.response.data);
                // }

            });
        }
    },

    // mounted() {
    //     const access_token = localStorage.getItem('access_token');
    //     if (is_logged && user_id) {
    //         window.location.replace('/');
    //     }
    // },

}
</script>

<style lang="scss">
    .login-content {
        display: flex;
        align-items: center;
        justify-content: center;

        .verification-code {
            //margin: 0 0 48px;
            .ui-checkbox {
                margin: 12px 4px;
                font-size: 12px;
            }
        }

        .form-wrap {
            .ui-checkbox {
                margin: 0;
                font-size: 12px;
            }

            &.show-error {
                .ui-input .ui-input--wrap select, 
                .ui-input .ui-input--wrap input, 
                .ui-input .ui-input--select select, 
                .ui-input .ui-input--select input {
                    border-color: var(--alert);
                }
            }
        }

        .error-text {
            margin: 8px 0 16px;
            font-size: 12px;
            color: var(--alert);

            a {
                color: var(--alert);
                text-decoration: underline;
            }

            ol {
                margin: 8px 0 8px 16px;
                padding: 0;
                list-style: disc;

                li {
                    margin: 0 0 2px;
                }
            }
        }

        .submit-wrap {
            margin: 44px 16px ;
            text-align: center;

            .ui-button {
                display: block;
                width: 180px;
                text-align: center;
                margin: 0 auto 16px;
            }

            a {
                font: var(--font-fg-12);
                color: var(--dark-blue);
            }
        }
    }
</style>